import { Link , NavLink} from "react-router-dom";
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import React, {Fragment, useEffect, useRef, useState} from "react";
import LazyLoad from 'react-lazy-load';
import {Skeleton} from "@mui/material";
import { MiniSearch , MiniUp , MiniBlackLocation} from '../assets/icones/icones';
import CallIcon from '@mui/icons-material/Call';
import clientconfigwebapp, {
    Agent_address_get_data,
    check_login_appbk,
    convert_to_english_strhk,
    empty_bk,
    getLengt_bk, scrollTo_uphk,
    Token_get_appbk
} from "../clientconfigwebapp";




import './assets/css/aside.css'









const Aside = (props) => {



    const [address_agent_text , set_address_agent_text] = useState('');

    const [phone_number_agent_text , set_phone_number_agent_text] = useState('');

    useEffect(() => {

        var agent_name_bon=Agent_address_get_data("address_agent");
        var phone_number_agent_bon=Agent_address_get_data("phone_number_agent");

        if(!empty_bk(agent_name_bon)){
            set_address_agent_text(agent_name_bon);
        }

        if(!empty_bk(phone_number_agent_bon)){
            set_phone_number_agent_text(phone_number_agent_bon);
        }




    });






    const asideMenu = useRef(null);
    const asideSvg = useRef(null);

    const [data_category_box_seach_box, set_data_category_box_seach_box] = useState([]);



     const infoData = [
        {
            day : 'شنبه',
            time: '07:45 - 21:30',
        },
        {
            day : 'یکشنبه',
            time: '07:45 - 21:30',
        },
        {
            day : 'دوشنبه',
            time: '07:45 - 21:30',
        },
        {
            day : 'سه شنبه',
            time: '07:45 - 21:30',
        },
        {
            day : 'چهارشنبه',
            time: '07:45 - 21:30',
        },
         {
             day : 'پنج شنبه',
             time: '07:45 - 21:30',
         },
         {
             day : 'جمعه',
             time: '10:15 - 21:30',
         },
     ]

     const asideMenuHandler = () => {
        asideMenu.current.classList.toggle('aside_active');
        asideSvg.current.classList.toggle('aside-svg-active');
     }

    const[custom_serarch_box_title,set_custom_serarch_box_title] = useState('');

    const Handler_custom_serarch_box=(event)=>{
        set_custom_serarch_box_title(convert_to_english_strhk(event.target.value));
    }


    useEffect(() => {
        Handler_serarch_box();
    }, [custom_serarch_box_title])

    const Handler_serarch_box = () => {


        if(empty_bk(custom_serarch_box_title)==false) {
            /// if(validateResult){
            const data_form_add = {title_search:String(custom_serarch_box_title)}; //filter_search:String(filter_search)

            console.log(data_form_add,"eeeeeeeee")

            if (data_form_add != null) {


                axios.post(`${clientconfigwebapp.siteurl}api/v1/search-category`,data_form_add)
                    .then((res) => {
                        ///Setloadinghkfullshow_search("false");

                        console.log(res.data, "777777777");


                        if(String(res.data.data_category_box).length > 0) {

                            // /console.log(res.data.data, "is 657567");
                            if (res.data.status=="success"){

                                if(String(res.data.data_category_box).length > 0) {  set_data_category_box_seach_box(res.data.data_category_box); }


                            }else {
                                toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            }


                        }else{
                          /////  Setloadinghkfullshow_search("false");
                            if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        }

                        ///localStorage.setItem('token',response.data.Auth.access_token)
                    }).catch((err) =>{

                   ///// console.log("rrrr", "777777777");

                   //// Setloadinghkfullshow_search("false");
                    toast.error('خطای اتصال به سرور اینترنت خود را چک کنید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                   ///// console.error(err, "is error 4535!");

                });


               /// Setloadinghkfullshow_search("false");
            }else{
               ///// Setloadinghkfullshow_search("false");
                alert('errcode:345765');
            }

        }else{
            set_data_category_box_seach_box([]);
        }

    }




    const scrollToSection =(element_Getname) => {


       const element = document.getElementById(element_Getname);




        //// element.scrollIntoView({ behavior: 'smooth' });

        const yOffset = -120;

         /// y = event.target.getBoundingClientRect().top + window.pageYOffset + yOffset;
         const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({top: y, behavior: 'smooth'});




        // html {
        //     scroll-behavior: smooth;
        // }


    };

    return (
        <>






            <aside className={" flexColStartStart aside-container " + String(props.costume_class)}>

                {   props.data_category_box.length > 0 ?  (

                    <Fragment>
                        <section className='w-100'>
                            <div  className={"title-menu-cat-home"}>منوی سفارش</div>
                            <label className='w-100 flexRowBetCenter'>
                                <input autoComplete={"off"}  onChange={Handler_custom_serarch_box}  type="text" id="custom_serarch_box_title" name="custom_serarch_box_title" className="inputbox-dark-bk"  style={{"direction":"rtl"}} placeholder="جستجو..." />

                                <MiniSearch />
                            </label>



                            {  data_category_box_seach_box.length > 0 ?  (
                                <Fragment>

                                    <ul className={"cat-sidebar-items"}>
                                        {data_category_box_seach_box.map((item, index) => {
                                            return (
                                                <li  key={index}>
                                                    <a href={"#sec-" + item.id_post} className={({isActive}) => isActive ? 'flexRowStartCenter active-link' : 'flexRowStartCenter' }>
                                                        <img className={"cat-icon-side-bar"} src={item.image_src} alt={item.title_post} />
                                                        <span>{item.title_post}</span>
                                                    </a>
                                                </li>
                                            )
                                        })}
                                    </ul>

                                </Fragment>

                            ) : (<Fragment>
                                <ul className={"cat-sidebar-items"}>
                                    {props.data_category_box.map((item, index) => {
                                        return (
                                            <li key={index}>
                                                <a href={"#sec-" + item.id_post} className={({isActive}) => isActive ? 'flexRowStartCenter active-link' : 'flexRowStartCenter' }>
                                                    <img  className={"cat-icon-side-bar"} src={item.image_src} alt={item.title_post} />
                                                    <span>{item.title_post}</span>
                                                </a>
                                            </li>
                                        )
                                    })}
                                </ul>
                            </Fragment>)   }








                        </section>
                        <section className='w-100' ref={asideMenu}>
                            <button type={"button"} className='w-100 flexRowCenterCenter sidebar-info-call' onClick={asideMenuHandler} >
                                <span className={"sidebar-info-title"}>اطلاعات مجموعه</span>
                                <span ref={asideSvg}>
                            <MiniUp />
                        </span>
                            </button>
                            <div className='w-100'>
                                <span className={"title-side-bar-sec"} style={{"paddingRight":"0.75rem"}}>سرویس دهی آنلاین</span>

                                <ul className='w-100'>
                                    {infoData.map((item, index) => {
                                        return (
                                            <li key={index} className='w-100 flexRowBetCenter'>
                                                <span>{item.day}</span>
                                                <span>{item.time}</span>
                                            </li>
                                        )
                                    })}
                                </ul>


                                <div className='flexColStartStart'>
                            <span className='flexRowStartCenter title-side-bar-sec'>
                                <MiniBlackLocation />
                                آدرس مجموعه
                            </span>
                                    <span className={"sub-title-side-bar-sec"}>{     String(address_agent_text) }</span>
                                </div>


                                <div className='flexColStartStart' style={{"paddingTop":"9px","borderTop":"solid 1px #d2d2d2"}}>
                            <span className='flexRowStartCenter title-side-bar-sec'>
                                <CallIcon />
                                تلفن تماس
                            </span>
                                    <span className={"sub-title-side-bar-sec"}><a href={"tel:" +  String(phone_number_agent_text) } style={{"fontFamily":"'KalamehWeb_Regular'","letterSpacing":"2px"}}><span>{  String(phone_number_agent_text) }</span></a></span>
                                </div>




                            </div>
                        </section>
                    </Fragment>

                ) : (
                    <Fragment>
                        <Skeleton variant="rectangular"  style={{"width":"100%","height":"40vh","marginTop":"0px","borderRadius":"12px"}}  />
                        <Skeleton variant="rectangular"  style={{"width":"100%","height":"40vh","marginTop":"10px","borderRadius":"12px"}}  />
                    </Fragment>
                )   }






            </aside>




            <div className={"mobile_cat_home"} style={{display:"none"}}>


                <div className="box_scroll_horizontal">

                    {

                        props.data_category_box.length==0 ?  (
                            <React.Fragment>

                                <Skeleton variant="rectangular" width={130} height={130}   style={{marginTop: "5px"}} />

                                <Skeleton variant="rectangular" width={130} height={130}   style={{marginTop: "5px"}} />
                                <Skeleton variant="rectangular" width={130} height={130}   style={{marginTop: "5px"}} />
                                <Skeleton variant="rectangular" width={130} height={130}   style={{marginTop: "5px"}} />
                                <Skeleton variant="rectangular" width={130} height={130}   style={{marginTop: "5px"}} />
                                <Skeleton variant="rectangular" width={130} height={130}   style={{marginTop: "5px"}} />

                            </React.Fragment>


                        ) : (


                            props.data_category_box.map((item_post,index) => {

                                return (

                                    <div className="item_cat_mobile" >
                                        {
                                            <button style={{"border":"none","backgroundColor":"transparent"}} type={"button"}  onClick={(event) => scrollToSection("sec-" + String(item_post.id_post)) }    href={"#sec-" + item_post.id_post} className={({isActive}) => isActive ? 'flexRowStartCenter active-link-cat' : 'flexRowStartCenter' }>
                                                <LazyLoad threshold={0.95}>
                                                    <img className="image-cat-mobile"  src={item_post.image_src} />
                                                </LazyLoad>
                                                <span className={"title-cat-mobile"}>{item_post.title_post}</span>
                                            </button>

                                        }
                                        <span></span>

                                    </div>

                                );

                            })

                        )
                    }

                </div>





            </div>



        </>
    )
}
export default Aside;